module.exports = __webpack_public_path__ + "static/media/Pescara.54882737.png";